import * as types from './mutation-types'

export const fetchContacts = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/contacts`, { params }).then((response) => {
            commit(types.SET_CONTACTS, response.data.contacts.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const addContact = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/contacts', data).then((response) => {
            if(response.data.result==true){
                commit(types.ADD_CONTACT, response.data)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const updateContact = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`/api/contacts/${data.id}`, data).then((response) => {
            if (response.data.result == true){
               commit(types.UPDATE_CONTACT, response.data)
            }
        resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const unsetContacts = ({ commit, dispatch, state }, data) => {
    commit(types.SET_CONTACTS, [])
}
